module.exports = __webpack_public_path__ + "img/teaser_traktor7.12fea732.jpg";